import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { KTX2Loader } from 'three/examples/jsm/loaders/KTX2Loader.js'
import staticPath from './staticPath'

export default class ImportGltf {
	static defaults = {
		renderer: null,
		dracoPath: staticPath('draco/'),
		transcoderPath: staticPath('basis/'),
		castShadow: true,
		receiveShadow: true,
	}

	constructor(url, options = {}) {
		this.url = url
		this.options = { ...ImportGltf.defaults, ...options }
		this.#setupLoader()
	}

	#setupLoader() {
		this.loader = new GLTFLoader()

		if (this.options.dracoPath) {
			this.dracoLoader = new DRACOLoader().setDecoderPath(this.options.dracoPath)
			this.loader.setDRACOLoader(this.dracoLoader)
		}

		if (!this.options.transcoderPath || !this.options.renderer) return

		this.ktx2Loader = new KTX2Loader()
			.setTranscoderPath(this.options.transcoderPath)
			.detectSupport(this.options.renderer)

		this.loader.setKTX2Loader(this.ktx2Loader)
	}

	load(onProgress) {
		return new Promise((resolve, reject) => {
			this.loader.load(
				this.url,
				gltf => {
					this.gltf = gltf
					this.model = gltf.scene

					this.model.traverse(child => {
						if (!child.isMesh) return

						child.castShadow = this.options.castShadow
						child.receiveShadow = this.options.receiveShadow
					})

					resolve(this.model)
				},
				event => {
					if (!event.total) return

					onProgress?.(event.loaded / event.total)
				},
				error => {
					console.error(`ImportGltf failed for ${this.url}`, error)
					reject(error)
				}
			)
		})
	}

	dispose() {
		this.model?.traverse(child => {
			if (!child.isMesh) return

			child.geometry?.dispose()

			const materials = Array.isArray(child.material) ? child.material : [child.material]

			for (const material of materials) {
				for (const value of Object.values(material ?? {})) {
					if (value?.isTexture) value.dispose()
				}

				material?.dispose()
			}
		})

		this.dracoLoader?.dispose()
		this.ktx2Loader?.dispose()
		this.model = null
		this.gltf = null
	}
}
